function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import { useRef, useEffect } from 'react';
import { isEqual, deepMix } from '@antv/util';
import { utils } from '../util';
import createNode from '../util/createNode';
export default function useInit(ChartClass, config) {
  var chart = useRef();
  var chartOptions = useRef();
  var container = useRef(null);
  /**
   * Get data base64
   * @param {string} type A DOMString indicating the image format. The default format type is image/png.
   * @param {number} encoderOptions A Number between 0 and 1 indicating the image quality
   */

  var toDataURL = function toDataURL() {
    var _chart$current;

    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image/png';
    var encoderOptions = arguments.length > 1 ? arguments[1] : undefined;
    return (_chart$current = chart.current) === null || _chart$current === void 0 ? void 0 : _chart$current.chart.canvas.cfg.el.toDataURL(type, encoderOptions);
  };
  /**
   * Download Iamge
   * @param {string} name A name of image
   * @param {string} type A DOMString indicating the image format. The default format type is image/png.
   * @param {number} encoderOptions A Number between 0 and 1 indicating the image quality
   */


  var downloadImage = function downloadImage(name) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/png';
    var encoderOptions = arguments.length > 2 ? arguments[2] : undefined;

    try {
      var _chart$current2; // default png


      if (name && name.indexOf('.') === -1) {
        name = "".concat(name, ".png");
      }

      var imageName = name;

      if (!imageName) {
        var _config$title;

        var _config = config; // 默认值：图表 title -> 图表类型

        imageName = "".concat((_config === null || _config === void 0 ? void 0 : (_config$title = _config.title) === null || _config$title === void 0 ? void 0 : _config$title.text) || (ChartClass === null || ChartClass === void 0 ? void 0 : ChartClass.name), ".png");
      }

      var base64 = (_chart$current2 = chart.current) === null || _chart$current2 === void 0 ? void 0 : _chart$current2.chart.canvas.cfg.el.toDataURL(type, encoderOptions);
      var a = document.createElement('a');
      a.href = base64;
      a.download = imageName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      a = null;
    } catch (err) {
      console.log(err);
    }
  };

  var processConfig = function processConfig() {
    var _config$statistic; // @ts-ignore 该属性只有 Liquid 和 Dount 存在且配置不一致，类型定义先忽略


    if ((_config$statistic = config.statistic) === null || _config$statistic === void 0 ? void 0 : _config$statistic.htmlContent) {
      // @ts-ignore
      var statisticHtmlContent = config.statistic.htmlContent; // @ts-ignore

      config.statistic.htmlContent = function () {
        var statisticDom = statisticHtmlContent.apply(void 0, arguments);

        if (utils.isType(statisticDom, 'String') || utils.isType(statisticDom, 'Number') || utils.isType(statisticDom, 'HTMLDivElement')) {
          return statisticDom;
        }

        return createNode(statisticDom);
      };
    }

    if (_typeof(config.tooltip) === 'object') {
      var _config$tooltip, _config$tooltip2;

      if ((_config$tooltip = config.tooltip) === null || _config$tooltip === void 0 ? void 0 : _config$tooltip.container) {
        config.tooltip.container = createNode(config.tooltip.container);
      }

      if ((_config$tooltip2 = config.tooltip) === null || _config$tooltip2 === void 0 ? void 0 : _config$tooltip2.customContent) {
        var customContent = config.tooltip.customContent;

        config.tooltip.customContent = function (title, items) {
          var tooltipDom = customContent(title, items) || '';

          if (utils.isType(tooltipDom, 'HTMLDivElement')) {
            return tooltipDom;
          }

          return createNode(tooltipDom);
        };
      }
    }
  };

  useEffect(function () {
    if (chart.current && !isEqual(chartOptions.current, config)) {
      var changeData = false;

      if (chartOptions.current) {
        // 从 options 里面取出 data 、value 、 percent 进行比对，判断是否仅数值发生改变
        var _chartOptions$current = chartOptions.current,
            cuurentData = _chartOptions$current.data,
            cuurentValue = _chartOptions$current.value,
            cuurentPercent = _chartOptions$current.percent,
            currentConfig = _objectWithoutProperties(_chartOptions$current, ["data", "value", "percent"]);

        var inputData = config.data,
            inputValue = config.value,
            inputPercent = config.percent,
            inputConfig = _objectWithoutProperties(config, ["data", "value", "percent"]);

        changeData = isEqual(currentConfig, inputConfig);
      }

      if (changeData) {
        chart.current.changeData((config === null || config === void 0 ? void 0 : config.data) || []);
      } else {
        processConfig();
        chart.current.update(deepMix(chart.current.options, config));
      }

      chartOptions.current = config;
    }
  }, [config]);
  useEffect(function () {
    if (!container.current) {
      return function () {
        return null;
      };
    }

    processConfig();
    var chartInstance = new ChartClass(container.current, _objectSpread({}, config));

    chartInstance.__proto__.toDataURL = function (type, encoderOptions) {
      return toDataURL(type, encoderOptions);
    };

    chartInstance.__proto__.downloadImage = function (name, type, encoderOptions) {
      return downloadImage(name, type, encoderOptions);
    };

    chartInstance.render();

    if (!chartOptions.current) {
      chartOptions.current = config;
    }

    chart.current = utils.clone(chartInstance);
    return function () {
      chartInstance.destroy();
    };
  }, []);
  return {
    chart: chart,
    container: container
  };
}